import { conditions } from "helpers";
import { ConditionName, SettingSections } from "interfaces";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { setSelectedAudioId } from "redux-share/slices/videoDataSlice";
import ChevronRightIcon from "../../icon-components/chevronRight";
import { shallowEqual } from "react-redux";
import { memo } from "react";

const MultiAudio = ({ setSection }: any) => {
    const dispatch = useAppDispatch();
    const { multiAudio, selectedAudioId } = useAppSelector(
        ({ videoData: { multiAudio, selectedAudioId } }) => ({ multiAudio, selectedAudioId }),
        shallowEqual
    );

    return (
        <div id={SettingSections.multiAudio} className="animate__animated animate__fadeIn pl-p-[14px]">
            <div
                className={`pl-flex pl-items-center pl-gap-2 pl-cursor-pointer pl-pb-3 pl-mb-3 pl-border-b pl-border-b-gray-300 dark:pl-border-b-dark-4`}
                onClick={() => setSection(SettingSections.main)}
            >
                <div className={`pl-rounded-[4px] pl-p-1 pl-bg-gray-300 dark:pl-bg-dark-4`}>
                    <ChevronRightIcon className={`pl-w-3 pl-h-3 pl-stroke-gray-800`} />
                </div>
                <p className="pl-text-[15px] pl-font-medium">انتخاب زبان</p>
            </div>
            <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                {conditions(ConditionName.hasMultiAudio) &&
                    multiAudio.map((audio: any, index: number) => (
                        <li
                            key={audio.id}
                            className={`pl-flex pl-items-center pl-text-[14px] pl-rounded-[4px] pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 pl-pr-2 ${
                                selectedAudioId === index && "pl-bg-main-light hover:!pl-bg-main-light pl-text-dark-5"
                            }`}
                            onClick={() => {
                                dispatch(setSelectedAudioId(index));
                                setSection(SettingSections.main);
                                dispatch(setActiveElements(false));
                                dispatch(setSettingPopover(false));
                            }}
                        >
                            <span>{audio.name}</span>
                            {index === 0 && <span>(پیش فرض)</span>}
                        </li>
                    ))}
            </ul>
        </div>
    );
};

export default memo(MultiAudio);
